export const metricSupportsSource = (metric, source) => {
  const sources = metric?.sources || [metric?.source || 'trips']
  return sources.includes(source)
}

export const reconcileConstructorSelection = ({ dimensions = [], metrics = [] }, selection = {}) => {
  const x = dimensions.some((item) => item.id === selection.x) ? selection.x : dimensions[0]?.id || ''
  const xSource = dimensions.find((item) => item.id === x)?.source || 'trips'
  const yItem = dimensions.find((item) => item.id === selection.y)
  const y = yItem && yItem.kind !== 'time' && (yItem.source || 'trips') === xSource ? yItem.id : ''
  const compatibleMetrics = metrics.filter((item) => metricSupportsSource(item, xSource))
  const metric = compatibleMetrics.some((item) => item.id === selection.metric)
    ? selection.metric
    : compatibleMetrics[0]?.id || ''
  return { x, y, metric, compatibleMetrics }
}

export const isRetryableRequestError = (error) => {
  const status = error?.response?.status
  return !status || status === 408 || status === 429 || status >= 500
}
